import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { BookingSelectors } from '../../../redux/reducers/bookingSlice';
import {
  COORDINATES_ERROR,
  COORDINATES_REG,
  EMAIL_ERROR,
  EMAIL_REG,
  REQUIRED_FIELD_ERROR,
  TELEGRAM_REG,
  TELEPHONE_ERROR,
  TOTAL_INFO_ERROR,
} from '../../../utils/constants';

const useValidationSchema = () => {
  const isValid = useSelector(BookingSelectors.getIsTelephoneValid);

  const contactsValidationSchema = Yup.object().shape({
    email: Yup.string()
      .notRequired()
      .email(EMAIL_ERROR)
      .matches(EMAIL_REG, EMAIL_ERROR)
      .max(100, 'Максимальное количество знаков 100'),

    phone: Yup.object().shape({
      country_code: Yup.string(),
      phone_code: Yup.string(),
      phone_number: Yup.string()
        .required(REQUIRED_FIELD_ERROR)
        .test('is-valid-phone', TELEPHONE_ERROR, function (value) {
          return !isValid;
        }),
    }),

    lat: Yup.number()
      .required(REQUIRED_FIELD_ERROR)
      .transform((value, originalValue) => {
        return originalValue ? Number(originalValue) : 0;
      })
      .min(-90)
      .max(90),

    lon: Yup.number()
      .required(REQUIRED_FIELD_ERROR)
      .transform((value, originalValue) => {
        return originalValue ? Number(originalValue) : 0;
      })
      .min(-180)
      .max(180),
  });
  return contactsValidationSchema;
};

export default useValidationSchema;
